import { ButtonTheme } from '@philips-emr/tws-constants';
import { AbortableCloseEvent, CloseEvent } from '@philips-emr/tws-core/lib/component/types';

/* 
  There are four level urgency, that can be set in this enum
  -- Information
  -- Caution, 
  -- Warning,
  -- Danger
*/
export enum DialogType {
  DEFAULT = 'Default',
  INFORMATION = 'Information',
  WARNING = 'warning',
  CAUTION = 'caution',
  DANGER = 'danger',
}

export interface DialogProps {

  /**
   * The title of the Dialog.
   */
  title: string,

  /**
   * The description of the Dialog.
   */
  description: string,

  /**
   * Custom buttons that will be used for dialog type modals.
   */
  dockButtons: DialogButton[],

  /**
   * Event that will be invoked when the dialog closes.
   */
  onClose?: (event: CloseEvent) => void;

  onBeforeClose?: (event: AbortableCloseEvent) => void;

  /**
  * This shows the various levels of urgency that a dialog can have depending on how much emphasis is required
  */
  type?: DialogType;

}

export interface DialogButton {
  action?: () => void;
  title: string;
  type: ButtonTheme;
}

type Listener = (modal: DialogProps) => void;

interface DialogService {

  addListener: (fn: Listener) => () => void;

  open: (dialog: DialogProps) => void;

}

function createDialogService(): DialogService {
  const listeners: Set<Listener> = new Set();

  const addListener = (fn: Listener): () => void => {
    if (listeners.has(fn)) {
      throw Error('[Dialog Service]: This listener is already listening to new dialogs');
    }

    listeners.add(fn);

    return (): void => {
      listeners.delete(fn);
    };
  };

  const open = (props: DialogProps): void => listeners.forEach((listener) => listener(props));

  return {
    addListener,
    open: open,
  };

}

const dialogService = createDialogService();
export { dialogService as DialogService };
